import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment";
import { DatePicker } from "react-advance-jalaali-datepicker";
import Sidebar from "../../../partials/aside/Sidebar";
import helpersTime from "../../../../helpers/time";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import httpService from "../../../../services/httpServices/httpServices";
import typeAmountDiscount from "./type-amount";

export default function EditDiscount() {
  const initDiscount = {
    title: "",
    amount: "",
    count_use: "",
    conditions: {
      max_count_use_discount: 0,
      max_count_use_each_user: 0,
      min_count_days_category_user_site_publisher: 0,
      min_price_category_user_site_publisher: 0,
      rate_start_date_category_user_site_publisher: 0,
      rate_end_date_category_user_site_publisher: 0,
      start_date_discount: 0,
      end_date_discount: 0,
      users_which_can_use_discount: [],
    },
    type: "",
    type_amount: "",
    created_at: "",
  };

  const [discount, setDiscount] = useState(initDiscount);
  const [typeAmount, setTypeAmount] = useState();
  const [amount, setAmount] = useState(initDiscount.amount);
  const [users, setUsers] = useState([]);
  const [showUsers, setShowUsers] = useState(false);

  const [
    amountMinPriceCategoryUserSitePublisher,
    setAmountMinPriceCategoryUserSitePublisher,
  ] = useState(0);

  const [
    deactiveMinPriceCategoryUserSitePublisher,
    setDeactiveMinPriceCategoryUserSitePublisher,
  ] = useState(() => {
    return discount.conditions.min_price_category_user_site_publisher == 0
      ? true
      : false;
  });

  const [
    deactiveMinDayCountCategoryUserSitePublisher,
    setDeactiveMinDayCountCategoryUserSitePublisher,
  ] = useState(() => {
    return discount.conditions.min_count_days_category_user_site_publisher == 0
      ? true
      : false;
  });

  const [deactivateStartDateDiscount, setDeactivateStartDateDiscount] =
    useState(() => {
      return discount.conditions.start_date_discount == 0 ? true : false;
    });

  const [deactivateEndDateDiscount, setDeactivateEndDateDiscount] = useState(
    () => {
      return discount.conditions.end_date_discount == 0 ? true : false;
    }
  );

  const [startDateDatePicker, setStartDateDatePicker] = useState(null);
  const [endDateDatePicker, setEndDateDatePicker] = useState(null);

  const [
    startDateRateStartDateCategoryUserSitePublisher,
    setStartDateRateStartDateCategoryUserSitePublisher,
  ] = useState(null);
  const [
    endDateRateStartDateCategoryUserSitePublisher,
    setEndDateRateStartDateCategoryUserSitePublisher,
  ] = useState(null);

  const [
    startDateRateEndDateCategoryUserSitePublisher,
    setStartDateRateEndDateCategoryUserSitePublisher,
  ] = useState(null);
  const [
    endDateRateEndDateCategoryUserSitePublisher,
    setEndDateRateEndDateCategoryUserSitePublisher,
  ] = useState(null);

  const [
    deactivateLimitRateStartDateCategoryUserSitePublisher,
    setDeactivateLimitRateStartDateCategoryUserSitePublisher,
  ] = useState(() => {
    return discount.conditions.rate_start_date_category_user_site_publisher == 0
      ? true
      : false;
  });

  const [
    deactivateLimitRateEndDateCategoryUserSitePublisher,
    setDeactivateLimitRateEndDateCategoryUserSitePublisher,
  ] = useState(() => {
    return discount.conditions.rate_end_date_category_user_site_publisher == 0
      ? true
      : false;
  });

  const [deactivateLimitCountUseDiscount, setDeactivateLimitCountUseDiscount] =
    useState(() => {
      return discount.conditions.max_count_use_discount == 0 ? true : false;
    });

  const [deactivateCountUseViaUsers, setDeactivateCountUseViaUsers] = useState(
    () => {
      return discount.conditions.max_count_use_each_user == 0 ? true : false;
    }
  );

  const [
    deactivateWhichUsersCanUseDiscount,
    setDeactivateWhichUsersCanUseDiscount,
  ] = useState(() => {
    return discount.conditions.users_which_can_use_discount.length == 0
      ? true
      : false;
  });

  const getStartDateDiscount = () => {
    const startDateDiscount = document.querySelector("#start-date input").value;
    const hourDateDiscount = document.querySelector(
      "#hour-start-date-discount"
    ).value;
    const minuteDateDiscount = document.querySelector(
      "#minute-start-date-discount"
    ).value;

    return (
      startDateDiscount + "_" + hourDateDiscount + ":" + minuteDateDiscount
    );
  };

  const getEndDateDiscount = () => {
    const endDateDiscount = document.querySelector("#end-date input").value;
    const hourEndDateDiscount = document.querySelector(
      "#hour-end-date-discount"
    ).value;
    const minuteEndDateDiscount = document.querySelector(
      "#minute-end-date-discount"
    ).value;

    return (
      endDateDiscount + "_" + hourEndDateDiscount + ":" + minuteEndDateDiscount
    );
  };

  const [message, setMessage] = useState();
  const history = useHistory();
  const params = useParams();
  const discountID = params.id;

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    await editDiscountCampaignBanner(dataForm);
  };

  const editDiscountCampaignBanner = async (dataForm) => {
    const resultSendRequestEditDiscountCampaignBanner =
      await sendRequestEditDiscountCampaignBanner(dataForm);

    if (resultSendRequestEditDiscountCampaignBanner) {
      history.push(`/manage/discount/campaign-banner/all`);
      return;
    }
  };

  const sendRequestEditDiscountCampaignBanner = async (dataForm) => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/banner/" +
          discountID,
        { ...dataForm },
        headersRequest
      );
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return true;
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
  };

  const getRateStartDateCategoryUserSitePublisher = () => {
    const startRateStartDateCategoryUserSitePublisher = document.querySelector(
      "#start-rate-start-date-category-user-site-publisher input"
    ).value;
    const endRateStartDateCategoryUserSitePublisher = document.querySelector(
      "#end-rate-start-date-category-user-site-publisher input"
    ).value;
    return (
      startRateStartDateCategoryUserSitePublisher +
      "_" +
      endRateStartDateCategoryUserSitePublisher
    );
  };

  const getRateEndDateCategoryUserSitePublisher = () => {
    const startRateEndDateCategoryUserSitePublisher = document.querySelector(
      "#start-rate-end-date-category-user-site-publisher input"
    ).value;
    const endRateEndDateCategoryUserSitePublisher = document.querySelector(
      "#end-rate-end-date-category-user-site-publisher input"
    ).value;
    return (
      startRateEndDateCategoryUserSitePublisher +
      "_" +
      endRateEndDateCategoryUserSitePublisher
    );
  };

  const getDataForm = () => {
    const discountTitle = document.querySelector("#title").value;

    const discountAmountValue =
      typeAmount === typeAmountDiscount.typeAmountString.PRICE
        ? amount
        : document.querySelector("#amount").value;

    const conditionAmountMinPriceCategoryUserSitePublisher =
      deactiveMinPriceCategoryUserSitePublisher === false
        ? amountMinPriceCategoryUserSitePublisher
        : "0";

    const conditionMinDayCountCategoryUserSitePublisher =
      deactiveMinDayCountCategoryUserSitePublisher === false
        ? document.querySelector("#min-day-count-category-user-site-publisher")
            .value
        : "0";

    const conditionStartDateDiscount =
      deactivateStartDateDiscount === false ? getStartDateDiscount() : "0";

    const conditionEndDateDiscount =
      deactivateEndDateDiscount === false ? getEndDateDiscount() : "0";

    const conditionRateStartDateCategoryUserSitePublisher =
      deactivateLimitRateStartDateCategoryUserSitePublisher === false
        ? getRateStartDateCategoryUserSitePublisher()
        : "0";

    const conditionRateEndDateCategoryUserSitePublisher =
      deactivateLimitRateEndDateCategoryUserSitePublisher === false
        ? getRateEndDateCategoryUserSitePublisher()
        : "0";

    const conditionLimitCountUseDiscount =
      deactivateLimitCountUseDiscount === false
        ? document.querySelector("#active-limit-count-use-discount").value
        : "0";

    const conditionCountUseViaUsers =
      deactivateCountUseViaUsers === false
        ? document.querySelector("#active-count-use-via-users").value
        : "0";

    const conditionWhichUsersCanUseDiscount =
      deactivateWhichUsersCanUseDiscount === true
        ? getUsersIDCanUseDiscount()
        : [];

    const formData = {
      title: discountTitle,
      amount: discountAmountValue + "",
      type_amount:
        typeAmount === typeAmountDiscount.typeAmountString.PRICE ? "1" : "2",
      start_date_discount: conditionStartDateDiscount,
      end_date_discount: conditionEndDateDiscount,
      rate_start_date_category_user_site_publisher:
        conditionRateStartDateCategoryUserSitePublisher,
      rate_end_date_category_user_site_publisher:
        conditionRateEndDateCategoryUserSitePublisher,
      min_price_category_user_site_publisher:
        conditionAmountMinPriceCategoryUserSitePublisher + "",
      min_count_days_category_user_site_publisher:
        conditionMinDayCountCategoryUserSitePublisher,
      max_count_use_discount: conditionLimitCountUseDiscount,
      max_count_use_each_user: conditionCountUseViaUsers,
      users_which_can_use_discount: conditionWhichUsersCanUseDiscount,
    };

    return formData;
  };

  const getUsersIDCanUseDiscount = () => {
    const usersID = [];
    document.querySelectorAll(".permissions:checked").forEach((item) => {
      usersID.push(parseInt(item.value));
    });
    return usersID;
  };

  useEffect(() => {
    getDiscount();
    getAllUser();
  }, []);

  useEffect(() => {
    setTypeAmount(typeAmountDiscount.typeAmountValue[discount.type_amount]);

    setDeactivateWhichUsersCanUseDiscount(() => {
      return discount.conditions.users_which_can_use_discount.length == 0
        ? false
        : true;
    });

    setDeactiveMinPriceCategoryUserSitePublisher(() => {
      return discount.conditions.min_price_category_user_site_publisher == 0
        ? true
        : false;
    });

    setAmountMinPriceCategoryUserSitePublisher(
      discount.conditions.min_price_category_user_site_publisher
    );

    setDeactivateStartDateDiscount(() => {
      return discount.conditions.start_date_discount == 0 ? true : false;
    });

    setDeactivateEndDateDiscount(() => {
      return discount.conditions.end_date_discount == 0 ? true : false;
    });

    setDeactivateLimitRateStartDateCategoryUserSitePublisher(() => {
      return discount.conditions.rate_start_date_category_user_site_publisher ==
        0
        ? true
        : false;
    });

    setDeactivateLimitRateEndDateCategoryUserSitePublisher(() => {
      return discount.conditions.rate_end_date_category_user_site_publisher == 0
        ? true
        : false;
    });

    if (discount.conditions.start_date_discount) {
      setStartDateDatePicker(
        <DatePicker
          placeholder="انتخاب تاریخ"
          format="jYYYY/jMM/jDD"
          preSelected={helpersTime.convertGregorianToJalali(
            discount.conditions.start_date_discount.split("_")[0]
          )}
        />
      );
    }

    if (discount.conditions.end_date_discount) {
      setEndDateDatePicker(
        <DatePicker
          placeholder="انتخاب تاریخ"
          format="jYYYY/jMM/jDD"
          preSelected={helpersTime.convertGregorianToJalali(
            discount.conditions.end_date_discount.split("_")[0]
          )}
        />
      );
    }

    if (discount.conditions.rate_start_date_category_user_site_publisher) {
      setStartDateRateStartDateCategoryUserSitePublisher(
        <DatePicker
          placeholder="انتخاب تاریخ"
          format="jYYYY/jMM/jDD"
          preSelected={helpersTime.convertGregorianToJalali(
            discount.conditions.rate_start_date_category_user_site_publisher.split(
              "_"
            )[0]
          )}
        />
      );
      setEndDateRateStartDateCategoryUserSitePublisher(
        <DatePicker
          placeholder="انتخاب تاریخ"
          format="jYYYY/jMM/jDD"
          preSelected={helpersTime.convertGregorianToJalali(
            discount.conditions.rate_start_date_category_user_site_publisher.split(
              "_"
            )[1]
          )}
        />
      );
    }

    if (discount.conditions.rate_end_date_category_user_site_publisher) {
      setStartDateRateEndDateCategoryUserSitePublisher(
        <DatePicker
          placeholder="انتخاب تاریخ"
          format="jYYYY/jMM/jDD"
          preSelected={helpersTime.convertGregorianToJalali(
            discount.conditions.rate_end_date_category_user_site_publisher.split(
              "_"
            )[0]
          )}
        />
      );
      setEndDateRateEndDateCategoryUserSitePublisher(
        <DatePicker
          placeholder="انتخاب تاریخ"
          format="jYYYY/jMM/jDD"
          preSelected={helpersTime.convertGregorianToJalali(
            discount.conditions.rate_end_date_category_user_site_publisher.split(
              "_"
            )[1]
          )}
        />
      );
    }

    setDeactivateLimitCountUseDiscount(() => {
      return discount.conditions.max_count_use_discount == 0 ? true : false;
    });

    setDeactivateCountUseViaUsers(() => {
      return discount.conditions.max_count_use_each_user == 0 ? true : false;
    });

    setDeactiveMinDayCountCategoryUserSitePublisher(() => {
      return discount.conditions.min_count_days_category_user_site_publisher ==
        0
        ? true
        : false;
    });

    setAmount(discount.amount);
  }, [discount]);

  const getDiscount = async () => {
    const discount = await sendRequestGetDiscount(discountID);
    if (!discount) {
      return;
    }

    setDiscount(discount);
  };

  const sendRequestGetDiscount = async (discountID) => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/discount/manage/banner/" +
          discountID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAllUser = async () => {
    let users = await sendRequestGetAllUser();
    users = users.map((user) => {
      return {
        id: user.usr_id,
        firstname: user.firstname,
        lastname: user.lastname != undefined ? user.lastname : "",
      };
    });
    setUsers(users);
  };

  const sendRequestGetAllUser = async () => {
    let result;
    let headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/all",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }

    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return result.data.data;
  };

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }

    setAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const inputAmountMinPriceCategoryUserSitePublisherChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }

    setAmountMinPriceCategoryUserSitePublisher(parseInt(number));
  };

  const inputAmountMinPriceCategoryUserSitePublisherBeforeInputHandler = (
    e
  ) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const generateUserList = () => {
    if (users.length === 0) {
      return;
    }

    return (
      <div className="table-responsive">
        <table className="table table-bordered table-dark tbl-td-white-space table-hover m-0">
          <thead>
            <td>#</td>
            <td>شماره کاربر</td>
            <td>نام کاربر</td>
            <td>انتخاب</td>
          </thead>
          <tbody>
            {users.map((user, index) => {
              return (
                <tr key={user.id}>
                  <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                  <td>{user.id}</td>
                  <td>
                    {user.firstname} {"  "} {user.lastname}{" "}
                  </td>
                  <td>
                    <span>
                      <label className="adl-switch">
                        <input
                          type="checkbox"
                          className="permissions"
                          defaultChecked={discount.conditions.users_which_can_use_discount.includes(
                            user.id
                          )}
                          defaultValue={user.id}
                        />
                        <span className="adl-slider round"></span>
                      </label>
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-discount" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">اضافه کردن کد تخفیف</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="alert alert-info">
                <p>
                  کد تخفیف در کمپین های بنری , به مبلغ گروه نمایش دهنده اعمال
                  میشود و مبلغ کمپین , مبلغ بیعانه و مبلغ کل نیز تغییر میدهد
                </p>
                <p>
                  به طور مثال کاربری گروه نمایش دهنده دارد با مبلغ{" "}
                  <span className="letter-spacing-finance-number">۱۵۰,۰۰۰</span>
                  ۰ هزار تومان و زمان گروه نمایش دهنده او ۱۳ روزه است
                </p>
                <p>
                  مبلغ کمپین بنری = تعداد روز گروه نمایش دهنده * مبلغ گروه نمایش
                  دهنده
                </p>
                <p>
                  بدون کد تخفیف مبلغ کمپین کاربر مبلغ{" "}
                  <span className="letter-spacing-finance-number">
                    ۱,۹۵۰,۰۰۰
                  </span>{" "}
                  میباشد
                </p>
                <p className="letter-spacing-finance-number">
                  ۱,۹۵۰,۰۰۰ = ۱۵۰,۰۰۰ * ۱۳
                </p>
                <p>مبلغ بیعانه کمپین</p>
                <p className="letter-spacing-finance-number">
                  ۶۰۵,۰۰۰ = ۳ / ۱,۹۵۰,۰۰۰{" "}
                </p>
                <hr />
                <p>
                  در اینجا کد تخفیف ۳۰% , مبلغ گروه نمایش دهنده او را به مبلغ
                  <span className="letter-spacing-finance-number">
                    ۱۰۵,۰۰۰
                  </span>{" "}
                  ‌هزار تومان میرسید و مبلغ کمپین او به مبلغ{" "}
                  <span className="letter-spacing-finance-number px-2">
                    ۱,۳۶۵,۰۰۰
                  </span>
                  تومان میرسد
                </p>
                <p className="letter-spacing-finance-number">
                  ۱۰۵,۰۰۰ = ۱۵۰,۰۰۰ * ۷۰ / ۱۰۰
                </p>
                <p className="letter-spacing-finance-number">
                  ۱,۳۶۵,۰۰۰ = ۱۰۵,۰۰۰ * ۱۳
                </p>
                <p>مبلغ بیعانه کمپین</p>
                <p className="letter-spacing-finance-number">
                  ۴۵۵,۰۰۰ = ۳ / ۱,۳۶۵,۰۰۰
                </p>
              </div>
              <div id="alert-container"></div>
              {messageTag}
              <div className="col-8">
                <form onSubmit={sendForm}>
                  <div className="form-group py-2">
                    <label>عنوان تخفیف</label>
                    <input
                      type="text"
                      id="title"
                      className="form-control"
                      defaultValue={discount?.title}
                      required
                    />
                  </div>
                  <div className="form-group py-2">
                    <div className="d-flex align-items-center">
                      <span className="pl-2">
                        <label className="m-0">مقدار تخفیف</label>
                      </span>
                      <span className="bg-warning d-flex p-1 rounded mb-1">
                        <span className="pl-2">مبلغی</span>
                        <span className="d-flex align-items-center ">
                          <input
                            type="radio"
                            className="hover"
                            name="type-price-discount"
                            checked={
                              typeAmount ==
                              typeAmountDiscount.typeAmountString.PRICE
                                ? true
                                : false
                            }
                            onClick={(e) => {
                              setTypeAmount(
                                typeAmountDiscount.typeAmountString.PRICE
                              );
                            }}
                          />
                        </span>
                        <span className="px-2">درصدی</span>
                        <span className="d-flex align-items-center">
                          <input
                            type="radio"
                            className="hover"
                            name="type-price-discount"
                            checked={
                              typeAmount ==
                              typeAmountDiscount.typeAmountString.PERCENT
                                ? true
                                : false
                            }
                            onClick={(e) => {
                              setTypeAmount(
                                typeAmountDiscount.typeAmountString.PERCENT
                              );
                            }}
                          />
                        </span>
                      </span>
                    </div>
                    <div>
                      {typeAmount ===
                      typeAmountDiscount.typeAmountString.PRICE ? (
                        <div className="input-group">
                          <input
                            type="text"
                            id="amount"
                            className="form-control number-finance"
                            value={helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(amount)
                            )}
                            defaultValue={helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(amount)
                            )}
                            onChange={inputAmountChangeHandler}
                            onBeforeInput={inputAmountBeforeInputHandler}
                            dir="ltr"
                            required
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">تومان</span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {typeAmount ===
                      typeAmountDiscount.typeAmountString.PERCENT ? (
                        <div className="input-group">
                          <input
                            type="number"
                            min="1"
                            max="99"
                            id="amount"
                            className="form-control number-finance"
                            defaultValue={amount}
                            dir="ltr"
                            required
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">٪</span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="form-group py-2">
                    <div className="d-flex py-2">
                      <label className="m-0">
                        شرط حداقل مبلغ گروه نمایش دهنده برای تخفیف
                      </label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                checked={
                                  deactiveMinPriceCategoryUserSitePublisher
                                }
                                onChange={(e) => {
                                  setDeactiveMinPriceCategoryUserSitePublisher(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="input-group">
                      <input
                        type="text"
                        id="min-price-category-user-site-publisher"
                        className="form-control number-finance"
                        value={helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(
                            amountMinPriceCategoryUserSitePublisher
                          )
                        )}
                        onChange={
                          inputAmountMinPriceCategoryUserSitePublisherChangeHandler
                        }
                        onBeforeInput={
                          inputAmountMinPriceCategoryUserSitePublisherBeforeInputHandler
                        }
                        dir="ltr"
                        disabled={deactiveMinPriceCategoryUserSitePublisher}
                        required
                      />
                      <div className="input-group-append">
                        <span className="input-group-text">تومان</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group py-2">
                    <div className="d-flex pb-2">
                      <label>شرط حداقل تعداد روز نمایش</label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                checked={
                                  deactiveMinDayCountCategoryUserSitePublisher
                                }
                                onChange={(e) => {
                                  setDeactiveMinDayCountCategoryUserSitePublisher(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <input
                      type="number"
                      className="form-control"
                      id="min-day-count-category-user-site-publisher"
                      disabled={deactiveMinDayCountCategoryUserSitePublisher}
                      defaultValue={
                        deactiveMinDayCountCategoryUserSitePublisher == false
                          ? discount.conditions
                              .min_count_days_category_user_site_publisher
                          : ""
                      }
                      required
                    />
                  </div>
                  <div className="form-group py-2">
                    <div>
                      <div className="d-flex">
                        <label className="text-nowrap">
                          شرط تاریخ و ساعت شروع استفاده از کد تخفیف (ساعت را ۲۴
                          ساعته وارد کنید)
                        </label>
                        <div className="d-flex bg-warning  p-1 rounded align-self-start">
                          <div className="text-nowrap pr-2">
                            غیرفعال کردن شرط
                          </div>
                          <div className="pr-2">
                            <span>
                              <label className="adl-switch">
                                <input
                                  type="checkbox"
                                  checked={deactivateStartDateDiscount}
                                  onChange={(e) => {
                                    setDeactivateStartDateDiscount(
                                      (prevState) => !prevState
                                    );
                                  }}
                                />
                                <span className="adl-slider round"></span>
                              </label>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div
                        id="start-date"
                        className={`custom-data-picker ${
                          deactivateStartDateDiscount === true ? "d-none" : ""
                        } `}
                      >
                        {startDateDatePicker ? (
                          startDateDatePicker
                        ) : (
                          <span id="aaa">
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                            />
                          </span>
                        )}
                      </div>
                      <div className="text-nowrap pr-2">ساعت :</div>
                      <div className="px-2">
                        <input
                          className="form-control"
                          type="number"
                          id="hour-start-date-discount"
                          min="0"
                          max="23"
                          disabled={deactivateStartDateDiscount}
                          defaultValue={
                            deactivateStartDateDiscount == false &&
                            discount.conditions.start_date_discount
                              ? discount.conditions.start_date_discount
                                  .split("_")[1]
                                  .split(":")[0]
                              : ""
                          }
                          required
                        />
                      </div>
                      <div className="text-nowrap">دقیقه :</div>
                      <div className="pr-2">
                        <input
                          className="form-control"
                          type="number"
                          id="minute-start-date-discount"
                          min="0"
                          max="59"
                          disabled={deactivateStartDateDiscount}
                          defaultValue={
                            deactivateStartDateDiscount == false &&
                            discount.conditions.start_date_discount
                              ? discount.conditions.start_date_discount
                                  .split("_")[1]
                                  .split(":")[1]
                              : ""
                          }
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group py-2">
                    <div className="d-flex">
                      <label className="text-nowrap">
                        شرط تاریخ و ساعت پایان استفاده از کد تخفیف (ساعت را ۲۴
                        ساعته وارد کنید)
                      </label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                checked={deactivateEndDateDiscount}
                                onChange={(e) => {
                                  setDeactivateEndDateDiscount(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div
                        id="end-date"
                        className={`custom-data-picker ${
                          deactivateEndDateDiscount === true ? "d-none" : ""
                        } `}
                      >
                        {endDateDatePicker ? (
                          endDateDatePicker
                        ) : (
                          <span id="bbb">
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                            />
                          </span>
                        )}
                      </div>
                      <div className="text-nowrap pr-2">ساعت :</div>
                      <div className="px-2">
                        <input
                          className="form-control"
                          type="number"
                          id="hour-end-date-discount"
                          min="0"
                          max="23"
                          disabled={deactivateEndDateDiscount}
                          defaultValue={
                            deactivateEndDateDiscount == false &&
                            discount.conditions.end_date_discount
                              ? discount.conditions.end_date_discount
                                  .split("_")[1]
                                  .split(":")[0]
                              : ""
                          }
                          required
                        />
                      </div>
                      <div className="text-nowrap">دقیقه :</div>
                      <div className="pr-2">
                        <input
                          className="form-control"
                          type="number"
                          id="minute-end-date-discount"
                          min="0"
                          max="59"
                          disabled={deactivateEndDateDiscount}
                          defaultValue={
                            deactivateEndDateDiscount == false &&
                            discount.conditions.end_date_discount
                              ? discount.conditions.end_date_discount
                                  .split("_")[1]
                                  .split(":")[1]
                              : ""
                          }
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex">
                      <label className="text-nowrap">
                        شرط بازه تاریخ شروع گروه نمایش دهنده
                      </label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                checked={
                                  deactivateLimitRateStartDateCategoryUserSitePublisher
                                }
                                onChange={(e) => {
                                  setDeactivateLimitRateStartDateCategoryUserSitePublisher(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center pt-2">
                      <div>
                        <label>ابتدا بازه</label>
                        <span className="px-2">:</span>
                      </div>
                      <div
                        id="start-rate-start-date-category-user-site-publisher"
                        className={`custom-data-picker ${
                          deactivateLimitRateStartDateCategoryUserSitePublisher ===
                          true
                            ? "d-none"
                            : ""
                        } `}
                      >
                        {startDateRateStartDateCategoryUserSitePublisher ? (
                          startDateRateStartDateCategoryUserSitePublisher
                        ) : (
                          <span>
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                              preSelected={helpersTime.convertGregorianToJalali(
                                moment(helpersTime.getDateNow(1)).format(
                                  "YYYY/M/D"
                                )
                              )}
                            />
                          </span>
                        )}
                      </div>
                      <div className="pr-2">
                        <label> انتها بازه</label>
                        <span className="px-2">:</span>
                      </div>
                      <div
                        id="end-rate-start-date-category-user-site-publisher"
                        className={`custom-data-picker ${
                          deactivateLimitRateStartDateCategoryUserSitePublisher ===
                          true
                            ? "d-none"
                            : ""
                        } `}
                      >
                        {endDateRateStartDateCategoryUserSitePublisher ? (
                          endDateRateStartDateCategoryUserSitePublisher
                        ) : (
                          <span>
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                              preSelected={helpersTime.convertGregorianToJalali(
                                moment(helpersTime.getDateNow(1)).format(
                                  "YYYY/M/D"
                                )
                              )}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex">
                      <label className="text-nowrap">
                        شرط بازه تاریخ پایان گروه نمایش دهنده
                      </label>
                      <div className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">غیرفعال کردن شرط</div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                checked={
                                  deactivateLimitRateEndDateCategoryUserSitePublisher
                                }
                                onChange={(e) => {
                                  setDeactivateLimitRateEndDateCategoryUserSitePublisher(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center pt-2">
                      <div>
                        <label>ابتدا بازه</label>
                        <span className="px-2">:</span>
                      </div>
                      <div
                        id="start-rate-end-date-category-user-site-publisher"
                        className={`custom-data-picker ${
                          deactivateLimitRateEndDateCategoryUserSitePublisher ===
                          true
                            ? "d-none"
                            : ""
                        } `}
                      >
                        {startDateRateEndDateCategoryUserSitePublisher ? (
                          startDateRateEndDateCategoryUserSitePublisher
                        ) : (
                          <span>
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                              preSelected={helpersTime.convertGregorianToJalali(
                                moment(helpersTime.getDateNow(1)).format(
                                  "YYYY/M/D"
                                )
                              )}
                            />
                          </span>
                        )}
                      </div>
                      <div className="pr-2">
                        <label> انتها بازه</label>
                        <span className="px-2">:</span>
                      </div>
                      <div
                        id="end-rate-end-date-category-user-site-publisher"
                        className={`custom-data-picker ${
                          deactivateLimitRateEndDateCategoryUserSitePublisher ===
                          true
                            ? "d-none"
                            : ""
                        } `}
                      >
                        {endDateRateEndDateCategoryUserSitePublisher ? (
                          endDateRateEndDateCategoryUserSitePublisher
                        ) : (
                          <span>
                            <DatePicker
                              placeholder="انتخاب تاریخ"
                              format="jYYYY/jMM/jDD"
                              preSelected={helpersTime.convertGregorianToJalali(
                                moment(helpersTime.getDateNow(1)).format(
                                  "YYYY/M/D"
                                )
                              )}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex pb-2">
                      <label>شرط محدودیت بیشترین استفاده کد تخفیف</label>
                      <span className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">
                          استفاده کردن به شکل نامحدود :
                        </div>
                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                checked={deactivateLimitCountUseDiscount}
                                onChange={(e) => {
                                  setDeactivateLimitCountUseDiscount(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </span>
                    </div>
                    <input
                      type="number"
                      id="active-limit-count-use-discount"
                      className="form-control"
                      disabled={deactivateLimitCountUseDiscount}
                      required
                      defaultValue={
                        deactivateLimitCountUseDiscount == false
                          ? discount.conditions.max_count_use_discount
                          : ""
                      }
                    />
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex pb-2">
                      <label>
                        شرط محدودیت بیشترین استفاده کد تخفیف هر کاربر
                      </label>

                      <span className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="text-nowrap pr-2">
                          استفاده کردن به شکل نامحدود :
                        </div>

                        <div className="pr-2">
                          <span>
                            <label className="adl-switch">
                              <input
                                type="checkbox"
                                checked={deactivateCountUseViaUsers}
                                onChange={(e) => {
                                  setDeactivateCountUseViaUsers(
                                    (prevState) => !prevState
                                  );
                                }}
                              />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </span>
                    </div>
                    <input
                      type="number"
                      id="active-count-use-via-users"
                      className="form-control"
                      disabled={deactivateCountUseViaUsers}
                      required
                      defaultValue={
                        deactivateCountUseViaUsers == false
                          ? discount.conditions.max_count_use_each_user
                          : ""
                      }
                    />
                  </div>

                  <div className="form-group py-2">
                    <div className="d-flex">
                      <label className="align-self-center m-0">
                        استفاده کاربران از کد تخفیف :
                      </label>
                      <span className="d-flex bg-warning  p-1 rounded align-self-start">
                        <div className="pr-2">
                          <span>
                            <span className="bg-warning d-flex p-1 rounded mb-1">
                              <span className="pl-2">همه کاربران</span>
                              <span className="d-flex align-items-center ">
                                <input
                                  type="radio"
                                  className="hover"
                                  name="which-user"
                                  id="which-user"
                                  checked={
                                    deactivateWhichUsersCanUseDiscount === false
                                      ? "checked"
                                      : ""
                                  }
                                  onClick={(e) => {
                                    setDeactivateWhichUsersCanUseDiscount(
                                      false
                                    );
                                  }}
                                />
                              </span>
                              <span className="px-2">
                                فقط تعدادی از کاربران
                              </span>
                              <span className="d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="hover"
                                  name="which-user"
                                  id="which-user"
                                  checked={
                                    deactivateWhichUsersCanUseDiscount === true
                                      ? "checked"
                                      : ""
                                  }
                                  onClick={(e) => {
                                    setDeactivateWhichUsersCanUseDiscount(true);
                                  }}
                                />
                              </span>
                            </span>
                          </span>
                        </div>
                      </span>
                    </div>
                    <div
                      className={`
                      ${
                        deactivateWhichUsersCanUseDiscount === false
                          ? "d-none"
                          : ""
                      }
                    `}
                    >
                      <div></div>
                      <div
                        className={` ${
                          deactivateWhichUsersCanUseDiscount === false
                            ? "d-none"
                            : ""
                        }   pt-2   `}
                      >
                        {generateUserList()}
                      </div>
                    </div>
                  </div>

                  <div className="form-group py-2">
                    <button className="btn btn-primary">ویرایش کد تخفیف</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
